import { CONSTANTS_GENERATION__value_range } from '@shared/constants/CONSTANTS_GENERATION__value_range';
import { ENUM__ml_asset_family } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_family';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__field_graph_interaction } from '../../_fields/_base/_enums/ENUM__field_graph_interaction';
import { FIELD_PRIMITIVE__int_image_side } from '../../_fields/_primitives/number/FIELD_PRIMITIVE__int_image_side';
import { ENUM__invocation_type } from '../_base/ENUM__invocation_type';
import { INVOCATION_SPANDREL__upscaler } from './INVOCATION_SPANDREL__upscaler';

export class INVOCATION_SPANDREL__upscaler_to_side extends INVOCATION_SPANDREL__upscaler {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.INVOCATION_SPANDREL__UPSCALER_TO_SIDE;

  /*
   * FIELDS
   */

  @FIELD_PRIMITIVE__int_image_side.init_as_input(
    {
      value: 512,
      //
      value_range: CONSTANTS_GENERATION__value_range.IMAGE_SIZE_OUT,
      values_allowed: CONSTANTS_GENERATION__value_range.IMAGE_SIZE_OUT,
      //
      multiple_of: 8,
      //
      slider_step: 512,
      slider_step_values: [512, 1024, 2048],
    },
    { field_role: '📏 Target Longest Side', graph__interaction: ENUM__field_graph_interaction.VISIBLE_NON_CONNECTABLE },
  )
  target_longest_side!: FIELD_PRIMITIVE__int_image_side;

  /*
   *
   */

  /*
   * PROPERTIES
   */

  get family() {
    return ENUM__ml_asset_family.VISION_SPANDREL__UPSCALER;
  }

  /*
   * METHODS
   */

  constructor() {
    super(ENUM__invocation_type.SPANDREL__UPSCALER_TO_SIDE);
  }
}
